import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { DARCKCOLOR } from '../../helpers/Config';

const CustomButton = ({
  children,      
  onClick,        
  to,        
  disabled = false,    
  variant = 'contained',
  size = '14px',
  lineHeight = '20px',
  fontWeight = '400',
  fullWidth = true,
  height = '48px',
  backgroundColor = 'rgba(3, 132, 68, 1)',
  color = '#fff',
  borderRadius = '45px',
  border = '1px solid rgba(3, 132, 68, 1)',
  hoverBackgroundColor = '#fff',
  hoverColor = DARCKCOLOR,
  ...rest        
}) => {
  const buttonStyles = {
    height,
    backgroundColor,
    color,
    borderRadius,
    border,
    '&:hover': {
      backgroundColor: hoverBackgroundColor,
      color: hoverColor,
    },
  };

  return to ? (
    <Button
      component={Link}
      to={to}
      onClick={onClick}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      sx={buttonStyles}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  ) : (
    <Button
      onClick={onClick}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      sx={buttonStyles}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
